<template>
  <div class="login-view wh100">
    <div class="content flex-center">
      <h1 class="text-center">
        Log in to Riverside Tools
      </h1>

      <form @submit.prevent="handleSubmit">
        <label for="email">
          <input id="email"
                 v-model="user.email"
                 placeholder="Email" />
        </label>

        <label for="password">
          <input id="password"
                 type="password"
                 v-model="user.password"
                 placeholder="Password" />
        </label>

        <div>
          <button class="w100">
            Log in
          </button>
        </div>

        <div class="logo text-center">
          <img src="../assets/logo-white.png" alt="" />
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import {computed, reactive} from "vue";

  const { state, dispatch, commit } = useStore();
  const user = reactive({ email: '', password: '' });

  function handleSubmit () {
    dispatch('login', user);
  }
</script>

<style lang="scss">
  @import "../styles/vars";

  .login-view {
    @media only screen and (min-width: 0) {
      padding-top: 160px;
      background-color: #4a4a4a;
      .content {
        width: 100%;
        max-width: 450px;
        margin: 0 auto;
        padding: 48px 48px;
        background-color: rgb(21, 21, 21);
        flex-direction: column;
        border-radius: 16px;
        border: 1px solid rgb(43, 43, 43);
      }
      h1 {
        margin-bottom: 48px;
        font-size: 2.2rem;
        font-weight: 700;
        color: white;
      }
      form {
        label {
          display: block;
          margin-bottom: 8px;
          span {
            padding-bottom: 4px;
            display: block;
            font-size: 1.5rem;
          }
          input {
            width: 100%;
            padding: 8px 12px;
            height: 45px;
            font-size: 1.6rem;
            background-color: rgb(43, 43, 43);
            border: none;
            border-radius: 10px;
            color: white;
            &:focus {
              box-shadow: rgb(177, 150, 255) 0px 0px 0px 1px inset;
            }
          }
          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus,
          input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px rgb(43, 43, 43) inset !important;
            -webkit-text-fill-color: white !important; /* Or whatever text color you want */
            transition: background-color 5000s ease-in-out 0s;
          }
        }
        button {
          padding: 14px 36px;
          background-color: rgb(94, 58, 195);
          border-radius: 10px;
          color: white;
          font-size: 1.5rem;
          font-weight: 500;
        }
        .logo {
          margin-top: 40px;
          opacity: 0.8;
          img {
            width: 40%;
          }
        }
      }
    }
  }
</style>